import { RelationalActionParameter } from "./RelationalActionParameter";

export interface IRelational {
  actions: RelationalActionParameter[];
}

export function instanceOfIRelational(instance: any): instance is IRelational {
  return instance
      && (instance.actions !== undefined);
}
